/*
 * TWEET COFFEE — RANDOM LOGO EYE OPEN
 *
 * Normal state: original Shopify logo with one eye closed.
 * Animation: briefly open the eye, then immediately return
 * to the original logo.
 */

/*
 * TWEET COFFEE — LOGO WINK
 */

const TWEET_LOGO_WINK_ENABLED = true;

document.addEventListener('DOMContentLoaded', function () {

  if (!TWEET_LOGO_WINK_ENABLED) return;

  const desktopQuery = window.matchMedia('(min-width: 750px)');
  const reducedMotionQuery =
    window.matchMedia('(prefers-reduced-motion: reduce)');

  if (!desktopQuery.matches || reducedMotionQuery.matches) return;

  const openEyeLogo =
    'https://cdn.shopify.com/s/files/1/0630/2574/1879/files/tweet-coffee-logo-open-eye.png?v=1792441560';

  const logo = document.querySelector(
    'header img[alt*="tweet" i], header img[alt*="coffee" i], .header__heading-logo'
  );

  if (!logo) return;

  const closedSrc = logo.getAttribute('src');
  const closedSrcset = logo.getAttribute('srcset');

  const preloadOpen = new Image();
  preloadOpen.src = openEyeLogo;

  function openEye() {
    logo.removeAttribute('srcset');
    logo.src = openEyeLogo;
  }

  function closeEye() {
    logo.src = closedSrc;

    if (closedSrcset) {
      logo.setAttribute('srcset', closedSrcset);
    }
  }

  function blinkOpen() {
    if (document.hidden) return;

    openEye();
    const openDuration =
    Math.floor(Math.random() * (400 - 250 + 1)) + 250;

    setTimeout(function () {
    closeEye();
    }, openDuration);

  }

  function scheduleNextBlink() {
    const minDelay = 3000;
    const maxDelay = 7000;

    const delay =
      Math.floor(Math.random() * (maxDelay - minDelay + 1)) + minDelay;

    setTimeout(function () {
      blinkOpen();
      scheduleNextBlink();
    }, delay);
  }

  // First eye-open after 1 second.
  setTimeout(function () {
    blinkOpen();
    scheduleNextBlink();
  }, 1000);
});